import { Theme } from '@mui/material/styles';
import { Colors } from 'src/theme/palette';

// ----------------------------------------------------------------------

export function checkbox(theme: Theme) {
  return {
    MuiCheckbox: {
      styleOverrides: {
        root: {
          padding: "2px", // theme.spacing(1)

          svg: {
            color: Colors.darkGreen
          }
        },
      },
    },
  };
}
